import React from 'react';
import NumberHelpers from 'number_helpers';

import MediaObject from '../../components/MediaObject';
import ArrowChange from '../../components/ArrowChange';

const abbrSettings = {
  precision: 3,
  strip_insignificant_zeros: true,
  space_label: false,
  labels: { thousand: 'K', million: 'M', billion: 'B' },
};

const abbrPrecisionSettings = {
  ...abbrSettings,
  labels: { thousand: '', million: '' },
  significant: true,
  separator: ',',
  precision: 4,
};

const mediaObject = (
  app,
  mediaObjectWidth,
  permissions,
  onAppQuickViewOpen,
  onPubQuickViewOpen
) => (
  <MediaObject
    withoutStore
    style={{ maxWidth: mediaObjectWidth }}
    name={app.name}
    publisher_name={app.publisher_name}
    store={app.store}
    app_id={app.ref_no}
    publisher_id={app.publisher_id}
    icon_url={app.cdn_images ? app.cdn_images['32x32'] : app.icon_url}
    icon_url_2x={app.cdn_images ? app.cdn_images['64x64'] : app.icon_url}
    appQuickViewAllowed={permissions && permissions.allowAppQuickView}
    onAppQuickViewOpen={onAppQuickViewOpen}
    onPubQuickViewOpen={onPubQuickViewOpen}
  />
);

export default {
  trendingAppsRow:
    (apps, mediaObjectWidth, permissions) =>
    ({ kind, onAppQuickViewOpen, onPubQuickViewOpen }) =>
      apps[kind].map((app) => ({
        app_name: mediaObject(
          app,
          mediaObjectWidth,
          permissions,
          onAppQuickViewOpen,
          onPubQuickViewOpen
        ),
        name: app.name,
        last_24_hours: (
          <td className="text-right">
            <ArrowChange
              change={app.delta}
              labels={{ thousand: '', million: '' }}
              units=""
              separator=","
              precision={4}
              numberMethod="number_with_precision"
            />
          </td>
        ),
        last_24_hours_row: app.delta,
        rank: NumberHelpers.number_with_precision(app.rank, abbrPrecisionSettings),
        rank_7_days_ago: (
          <td className="text-right">
            {app.rank_7_days_ago
              ? NumberHelpers.number_with_precision(app.rank_7_days_ago, abbrPrecisionSettings)
              : '(not ranked)'}
          </td>
        ),
        rank_7_days_ago_row: app.rank_7_days_ago,
      })),
};
